import { z } from 'zod/v4';

/**
 * Aggregate counters for a single amfori sync run. Each field maps 1:1 to an
 * integer column on `amfori_sync_history` and is incremented by the phase
 * runners (sub-tasks 3–9) as work completes.
 *
 * All counters are non-negative integers and default to 0 so a freshly minted
 * `RUNNING` row, and any partially-completed run, always has a valid shape.
 */
export const AmforiSyncCountersSchema = z.object({
  auditsCreated: z.number().int().min(0).default(0),
  dataPointsWritten: z.number().int().min(0).default(0),
  findingsCreated: z.number().int().min(0).default(0),
  zeroToleranceCreated: z.number().int().min(0).default(0),
  suppliersMatched: z.number().int().min(0).default(0),
  suppliersUnmatched: z.number().int().min(0).default(0),
  errorsCount: z.number().int().min(0).default(0),
});

export type AmforiSyncCounters = z.infer<typeof AmforiSyncCountersSchema>;

/** The set of counter names that may be incremented individually. */
export const AMFORI_SYNC_COUNTER_KEYS = [
  'auditsCreated',
  'dataPointsWritten',
  'findingsCreated',
  'zeroToleranceCreated',
  'suppliersMatched',
  'suppliersUnmatched',
  'errorsCount',
] as const;

export type AmforiSyncCounterKey = (typeof AMFORI_SYNC_COUNTER_KEYS)[number];
